import script from "./EnrollDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollDialog.vue?vue&type=script&setup=true&lang=js"

import "./EnrollDialog.vue?vue&type=style&index=0&id=04b74e14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b74e14"]])

export default __exports__